import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { PermissionValidationSchema } from '../schemas/create.schema'

interface UseCreatePermissionProps {
  onSuccess: () => void
  onError: (error: ErrorResponse) => void
}

const useCreatePermission = ({ onSuccess, onError }: UseCreatePermissionProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['createPermission'],
    mutationFn: async (form: PermissionValidationSchema) => {
      const parsedProperties = form.properties && JSON.parse(form.properties?.replace(/'/g, '"'));

      const permission = {
        ...form,
        operation_klass: form.operation_klass.value,
        properties: parsedProperties
      }

      return privateAxios.post('/permissions', permission)
    },
    onSuccess,
    onError,
  })
}

export default useCreatePermission
